import React from "react";

export default function HomesForSale() {
  return <div>HomesForSale</div>;
}
